import Filters from '@master/Filters';

export default {
  install: Vue => {
    Object.keys(Filters).forEach(key => Vue.filter(key, Filters[key]));
  },
};
